import React, { useState, useEffect, useRef } from "react";
import Moment from "moment";
import api from "../../services/api";
import BreadCrumbDiv from "../../components/common/BreadCrumbDiv";
import SearchInput from "../../components/common/SearchInput";
import SearchWrapDiv from "../../components/common/SearchWrapDiv";
import SearchButton from "../../components/common/SearchButton";
import ButtonWrapDiv from "../../components/common/ButtonWrapDiv";
import DashboardDiv from "../../components/common/DashboardDiv";
import ListWrapDiv from "../../components/common/ListWrapDiv";
import FunctionButton from "../../components/common/FunctionButton";
import { Link } from "react-router-dom";
import PageBar from "../../components/common/PageBar";
import "react-dropdown-tree-select/dist/styles.css";
import CustomDropDownTreeSelect from "../../components/common/CustomDropDownTreeSelect";
import { useMenuAuthInfo } from "../../services/GlobalUtil";
import { useTranslation } from "react-i18next";
import LoadingBoxDiv from "../../components/common/LoadingBoxDiv";

const UserManagementPage = () => {
  const pageSize = 20;
  const menuAuthInfo = useMenuAuthInfo();
  const { t } = useTranslation();

  const [curPage, setCurPage] = useState(1);
  const [totalCount, setTotalCount] = useState();
  const [id, setId] = useState("");
  const [locationDlr, setLocationDlr] = useState([]);
  const searchId = useRef("");
  const searchRegion = useRef([]);

  const [dash, setDash] = useState([]);
  const [sbLocationDlr, setSbLocationDlr] = useState([]);
  const [datas, setDatas] = useState([]);
  const [checkUsers, setCheckUsers] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [isExcelLoading, setIsExcelLoading] = useState(false);

  const loadLocationLocData = () => {
    if (sbLocationDlr != null && sbLocationDlr.length > 0) {
      return;
    }

    api
      .post("/common/location-loc-tree", {})
      .then((response) => {
        setSbLocationDlr(response.data);
      })
      .catch(() => {});
  };

  const loadContentData = () => {
    setIsLoading(true);

    api
      .post("/manage/user/stat", {
        sUserId: searchId.current,
        sLocationLocs: searchRegion.current,
      })
      .then((response) => {
        setDash(response.data);
      })
      .catch(() => {});

    api
      .post("/manage/user/view", {
        userId: searchId.current,
        sLocationLocs: searchRegion.current,
        page: curPage,
        size: pageSize,
      })
      .then((response) => {
        setDatas(response.data.content);
        setTotalCount(response.data.totalCount);
        setIsLoading(false);
      })
      .catch(() => {});
  };

  useEffect(() => {
    if (menuAuthInfo.view) {
      loadContentData();
    }
  }, [curPage]);

  const handleIdChange = (e) => {
    setId(e.target.value.trim());
  };

  const handleCheckValue = (e) => {
    if (e.target.checked) {
      setCheckUsers((checkUsers) => [...checkUsers, e.target.value]);
    } else {
      setCheckUsers((checkUsers) =>
        checkUsers.filter((user) => user !== e.target.value)
      );
    }
  };

  const handleDeleteUser = () => {
    if (!checkUsers) {
      return;
    }

    api
      .post("/manage/user/delete", {
        ids: checkUsers,
      })
      .then(() => {
        loadContentData();
        setCheckUsers([]);
      })
      .catch(() => {});
  };

  const handleDownloadExcel = () => {
    if (isExcelLoading) {
      return;
    }
    setIsExcelLoading(true);
    api
      .post(
        "/manage/user/excel",
        {
          userId: searchId.current,
          sLocationLocs: searchRegion.current,
        },
        {
          responseType: "blob",
        }
      )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;

        link.setAttribute(
          "download",
          "UserMng_" + Moment().format("YYYYMMDD") + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        setIsExcelLoading(false);
      })
      .catch(() => {
        setIsExcelLoading(false);
      });
  };

  const handleSearch = () => {
    searchId.current = id;
    searchRegion.current = locationDlr;

    if (curPage === 1) {
      loadContentData();
    } else {
      setCurPage(1);
    }
  };

  const pageChange = (data) => {
    if (curPage === data) {
      return;
    }
    setCurPage(data);
  };

  return (
    <div>
      <BreadCrumbDiv items={[t("MENU:L0056"), t("MENU:L0072")]}></BreadCrumbDiv>
      <SearchWrapDiv>
        <ButtonWrapDiv>
          <SearchInput
            value={id}
            onChange={handleIdChange}
            placeholder={t("L0002")}
            maxLength={250}
          ></SearchInput>
          <CustomDropDownTreeSelect
            data={sbLocationDlr}
            placeholder={t("L0049")}
            isViewCode={true}
            flattenIntermediate={true}
            onChange={setLocationDlr}
            onFocus={loadLocationLocData}
          ></CustomDropDownTreeSelect>
          <SearchButton onClick={handleSearch}></SearchButton>
        </ButtonWrapDiv>
      </SearchWrapDiv>

      <ButtonWrapDiv className="btn_top">
        <FunctionButton
          value={t("L0150")}
          onClick={handleDownloadExcel}
          loading={isExcelLoading}
        ></FunctionButton>
        <FunctionButton
          className={"bg_gray"}
          value={t("L0091")}
          onClick={handleDeleteUser}
        ></FunctionButton>
      </ButtonWrapDiv>

      <LoadingBoxDiv loading={isLoading}>
        <DashboardDiv>
          <dl>
            <dt>{t("L0311")}</dt>
            <dd>{dash.idCnt}</dd>
          </dl>
          <dl>
            <dt>{t("L0117")}</dt>
            <dd>{dash.distCnt}</dd>
          </dl>
          <dl>
            <dt>{t("L0118")}</dt>
            <dd>{dash.portCnt}</dd>
          </dl>
          <dl>
            <dt>{t("L0119")}</dt>
            <dd>{dash.dealCnt}</dd>
          </dl>
          <dl>
            <dt>{t("L0315")}</dt>
            <dd>{dash.activeCnt}</dd>
          </dl>
          <dl>
            <dt>{t("L0316")}</dt>
            <dd>{dash.disableCnt}</dd>
          </dl>
        </DashboardDiv>

        <ListWrapDiv>
          <table>
            <colgroup>
              <col style={{ width: "5%" }} />
              <col style={{ width: "8%" }} />
              <col style={{ width: "8%" }} />
              <col style={{ width: "9%" }} />
              <col style={{ width: "9%" }} />
              <col style={{ width: "6%" }} />
              <col style={{ width: "12%" }} />
              <col style={{ width: "auto" }} />
              <col style={{ width: "8%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "10%" }} />
            </colgroup>
            <thead>
              <tr>
                <th></th>
                <th>{t("L0048")}</th>
                <th>{t("L0049")}</th>
                <th>{t("L0050")}</th>
                <th>{t("L0002")}</th>
                <th>{t("L0661")}</th>
                <th>{t("L0295")}</th>
                <th>{t("L0003")}</th>
                <th>{t("L0663")}</th>
                <th>{t("L0104")}</th>
                {menuAuthInfo.view && <th>{t("L0664")}</th>}
              </tr>
            </thead>
            <tbody>
              {datas.length === 0 ? (
                <tr>
                  <td colSpan={11} style={{ textAlign: "center" }}>
                    {t("L0094")}
                    <br />
                    {t("L0095")}
                  </td>
                </tr>
              ) : (
                datas.map((data, rowIndex) => (
                  <tr key={rowIndex}>
                    <td>
                      <input
                        type="checkbox"
                        name="user-check"
                        id={`user-check-${data["id"]}`}
                        value={data["id"]}
                        onChange={handleCheckValue}
                        checked={checkUsers.includes(data["id"].toString())}
                      />
                      <label htmlFor={`user-check-${data["id"]}`}></label>
                    </td>
                    <td>{t(`AREA:${data.area}`)}</td>
                    <td>{t(`UNITED:${data.united}`)}</td>
                    <td>{t(`CNTRY:${data.country}`)}</td>
                    <td>{data.userId}</td>
                    <td>{data.location}</td>
                    <td>{t(`AUTH:${data.auth}`)}</td>
                    <td>{data.eml}</td>
                    <td>{data.useYn}</td>
                    <td>{Moment(data.createDT).format("YYYY-MM-DD HH:mm:ss")}</td>
                    {menuAuthInfo.view && (
                      <td>
                        <Link
                          to="/manage/user/detail"
                          state={{
                            id: data["id"],
                          }}
                        >
                          {t("L0466")}
                        </Link>
                      </td>
                    )}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </ListWrapDiv>

        <PageBar
          TotalCount={totalCount}
          CurrentPage={curPage}
          CountPerPage={pageSize}
          MaxPageBarCount={10}
          onPageСhange={pageChange}
        ></PageBar>
      </LoadingBoxDiv>
    </div>
  );
};

export default UserManagementPage;
